import { render, staticRenderFns } from "./index.vue?vue&type=template&id=238c647d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=238c647d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238c647d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('238c647d')) {
      api.createRecord('238c647d', component.options)
    } else {
      api.reload('238c647d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=238c647d&scoped=true", function () {
      api.rerender('238c647d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configManage/orderType/index.vue"
export default component.exports